module.exports = __webpack_public_path__ + "static/media/package-detailimg.bb2997a0.png";